import api from '../lib/api';

import {
  setCurrentMembership,
} from './memberships';
import { extractCardExpirationParts } from '../lib/card-functions';
import { handle401 } from './error-handlers';

export const REQUEST_AUTHENTICATE_USER = 'REQUEST_AUTHENTICATE_USER';
export const AUTHENTICATE_USER = 'AUTHENTICATE_USER';
export const UNAUTHENTICATE_USER = 'UNAUTHENTICATE_USER';

export const REQUEST_USER_EXISTS = 'REQUEST_USER_EXISTS';
export const FETCH_USER_EXISTS = 'FETCH_USER_EXISTS';

export const REQUEST_GUEST_SIGN_UP = 'REQUEST_GUEST_SIGN_UP';
export const FETCH_GUEST_SIGN_UP = 'FETCH_GUEST_SIGN_UP';

export const REQUEST_USER_SIGNUP = 'REQUEST_USER_SIGNUP';
export const FETCH_USER_SIGNUP = 'FETCH_USER_SIGNUP';

export const SEND_MAGIC_LINK = 'SEND_MAGIC_LINK';
export const LOGIN_WITH_TOKEN = 'LOGIN_WITH_TOKEN';

export const REQUEST_PAYMENT_SOURCES = 'REQUEST_PAYMENT_SOURCES';
export const FETCH_PAYMENT_SOURCES = 'FETCH_PAYMENT_SOURCES';

export const REQUEST_CREATE_PAYMENT_SOURCE = 'REQUEST_CREATE_PAYMENT_SOURCE';
export const FETCH_CREATE_PAYMENT_SOURCE = 'FETCH_CREATE_PAYMENT_SOURCE';

export const REQUEST_UPGRADE_GUEST_USER = 'REQUEST_UPGRADE_GUEST_USER';
export const FETCH_UPGRADE_GUEST_USER = 'FETCH_UPGRADE_GUEST_USER';

export const REQUEST_TOKENIZE_CARD = 'REQUEST_TOKENIZE_CARD';
export const FETCH_TOKENIZE_CARD = 'FETCH_TOKENIZE_CARD';

export const REQUEST_USER_PURCHASES = 'REQUEST_USER_PURCHASES';
export const FETCH_USER_PURCHASES = 'FETCH_USER_PURCHASES';

export const REQUEST_UPDATE_USER = 'REQUEST_UPDATE_USER';
export const FETCH_USER_UPDATE = 'FETCH_USER_UPDATE';

export const REQUEST_RECOVER_PASSWORD = 'REQUEST_RECOVER_PASSWORD';
export const FETCH_RECOVER_PASSWORD = 'FETCH_RECOVER_PASSWORD';

export const REQUEST_SET_NEW_PASSWORD = 'REQUEST_SET_NEW_PASSWORD';
export const FETCH_SET_NEW_PASSWORD = 'FETCH_SET_NEW_PASSWORD';

export const REQUEST_UPDATE_USER_LANGUAGE = 'REQUEST_UPDATE_USER_LANGUAGE';
export const FETCH_UPDATE_USER_LANGUAGE = 'FETCH_UPDATE_USER_LANGUAGE';

export const REQUEST_IMPERSONATE_USER = 'REQUEST_IMPERSONATE_USER';

export const FETCH_USER = 'FETCH_USER';

export const fetchUser = (authentication) => {
  return (dispatch) => {
    const headers = {
      authorization: { bearer: authentication.token },
    };

    return api.get(`/user/`, headers)
      .then((response) => {
        return dispatch({ type: FETCH_USER, payload: response.data });
      });
  }
}

export const impersonateUser = (id, authentication) => (
  (dispatch) => {
    const headers = {
      authorization: { bearer: authentication.token },
    };

    dispatch({ type: REQUEST_IMPERSONATE_USER, payload: { id } });

    return api.post(`/users/${id}/impersonate`, {}, headers)
      .then((response) => {
        return dispatch({ type: AUTHENTICATE_USER, payload: response.data });
      })
      .catch(handle401(dispatch));
  }
);

export const authenticateUserWithPassword = (email, password) => (
  (dispatch) => {
    dispatch({ type: REQUEST_AUTHENTICATE_USER });
    return api.post('/users/authenticate', { email, password })
      .then((response) => {
        const result = dispatch({ type: AUTHENTICATE_USER, payload: response.data });
        dispatch(setCurrentMembership());
        return result;
      });
  }
);

export const connectWithFacebook = (data, authentication = null) => (
  (dispatch) => {
    const headers = {};

    if (authentication && authentication.token) {
      headers.authorization = { bearer: authentication.token };
    }

    dispatch({ type: REQUEST_AUTHENTICATE_USER });

    return api.post('/users/authenticate/facebook', data, headers)
      .then((response) => {
        const user = { ...response.data, guest: false };
        const result = dispatch({ type: AUTHENTICATE_USER, payload: user });
        dispatch(setCurrentMembership());
        return result;
      })
      .catch(handle401(dispatch));
  }
);

export const logout = () => {
  return (dispatch) => {
    dispatch(unauthenticateUser());
    window.location.reload();
  };
};

export const unauthenticateUser = () => {
  return (dispatch) => {
    dispatch({ type: UNAUTHENTICATE_USER });
    dispatch(setCurrentMembership());

    return Promise.resolve();
  };
};

export const guestSignUp = (email, fullName) => (
  (dispatch) => {
    dispatch({ type: REQUEST_GUEST_SIGN_UP, payload: { email } });
    return api.post('/users/guest', { email, fullName, createGuestAccount: true })
      .then((res) => {
        const data = {
          ...res.data,
          guest: true,
        };
        const result = dispatch({ type: FETCH_GUEST_SIGN_UP, payload: data });
        dispatch(setCurrentMembership());
        return result;
      });
  }
);

export const userSignUp = (email, password, fullName) => {
  return (dispatch) => {
    dispatch({ type: REQUEST_USER_SIGNUP, payload: { email, fullName } });
    return api.post('/users', { email, password, fullName })
      .then((res) => {
        const result = dispatch({ type: FETCH_USER_SIGNUP, payload: res.data });
        dispatch(setCurrentMembership());
        return result;
      });
  };
};

export const userExists = email => (
  (dispatch) => {
    if (!email) {
      return Promise.resolve(dispatch({ type: FETCH_USER_EXISTS, payload: false }));
    }
    dispatch({ type: REQUEST_USER_EXISTS, payload: { email } });

    return api.get('/users/exists', { params: { email } })
      .then(res => dispatch({ type: FETCH_USER_EXISTS, payload: res.data.exists }));
  }
);

export const sendMagicLink = (email) => {
  const data = { email };

  if (window.location.href.search('/login') === -1) {
    data['redirect'] = window.location.href;
  }

  return dispatch => (
    api.post('/users/authenticate/send_magic_link', data)
      .then(() => dispatch({ type: SEND_MAGIC_LINK }))
  );
};

export const loginWithToken = (props) => {
  return dispatch => (
    api.post('/users/authenticate/token', props)
      .then((res) => {
        const result = dispatch({ type: LOGIN_WITH_TOKEN, payload: res.data });
        dispatch(setCurrentMembership());
        return result;
      })
  );
};

export const fetchUserPaymentSources = (user, accessToken) => {
  const headers = {
    authorization: { bearer: accessToken },
  };
  return (dispatch) => {
    dispatch({ type: REQUEST_PAYMENT_SOURCES, payload: user });
    return api.get('/user/payment_sources', headers)
      .then(res => dispatch({ type: FETCH_PAYMENT_SOURCES, payload: { ...user, paymentSources: res.data } }))
      .catch(handle401(dispatch));
  };
};

export const createUserPaymentSource = (user, card, accessToken) => {
  const headers = {
    authorization: { bearer: accessToken },
  };

  return (dispatch) => {
    dispatch({ type: REQUEST_CREATE_PAYMENT_SOURCE, payload: user });

    const exp = extractCardExpirationParts(card.expDate);

    return api.post('/user/payment_sources', {
      token: card.paymentSource,
      platformId: card.platformId,
      info: {
        fullName: card.fullName,
        expMonth: exp.month,
        expYear: exp.year,
      },
    }, headers)
      .then(res => dispatch({
        type: FETCH_CREATE_PAYMENT_SOURCE, payload: { ...user, paymentSources: [res.data] },
      }))
      .catch(handle401(dispatch));
  };
};

export const upgradeGuestUser = (password, accessToken) => {
  const headers = {
    authorization: { bearer: accessToken },
  };
  return (dispatch) => {
    dispatch({ type: REQUEST_UPGRADE_GUEST_USER });
    return api.post('guest/user', { password }, headers)
      .then((res) => {
        const user = { ...res.data, guest: false };
        return dispatch({ type: FETCH_UPGRADE_GUEST_USER, payload: user });
      });
  };
};

export const fetchUserPurchases = (user, authentication) => {
  const headers = {
    authorization: { bearer: authentication.token },
  };
  return (dispatch) => {
    dispatch({ type: REQUEST_USER_PURCHASES, payload: user });
    return api.get('/user/purchases', headers)
      .then(res => dispatch({ type: FETCH_USER_PURCHASES, payload: { user, purchases: res.data } }))
      .catch(handle401(dispatch));
  };
};

export const updateUser = (user, data, authentication) => {
  const headers = {
    authorization: { bearer: authentication.token },
  };

  return (dispatch) => {
    dispatch({ type: REQUEST_UPDATE_USER, payload: user });
    return api.patch('/user', data, headers)
      .then((res) => {
        return dispatch({ type: FETCH_USER_UPDATE, payload: res.data });
      })
      .catch(handle401(dispatch));
  };
};

export const recoverUserPassword = (user, email) => {
  return (dispatch) => {
    dispatch({ type: REQUEST_RECOVER_PASSWORD, payload: user });
    return api.post('/users/send_recover_password_link', { email })
      .then(res => dispatch({ type: FETCH_RECOVER_PASSWORD, payload: res.data }));
  };
};

export const submitSignupForm = ({ email, password, fullName }) => {
  return (dispatch) => {
    return dispatch(userSignUp(email, password, fullName))
      .then(() => dispatch(authenticateUserWithPassword(email, password)));
  };
};

export const setNewUserPassword = ({ fullName, password }, resetPasswordToken) => {
  return (dispatch) => {
    dispatch({ type: REQUEST_SET_NEW_PASSWORD, payload: resetPasswordToken });
    return api.post('/user/recover_password', { password, fullName, resetPasswordToken })
      .then((response) => {
        return dispatch({ type: FETCH_SET_NEW_PASSWORD, payload: response.data });
      });
  };
};

export const updateUserLanguage = (languageCode, accessToken) => {
  return (dispatch) => {
    dispatch({ type: REQUEST_UPDATE_USER_LANGUAGE, payload: languageCode });

    if (!accessToken) {
      return Promise.resolve(
        dispatch({ type: FETCH_UPDATE_USER_LANGUAGE, payload: languageCode }),
      );
    }

    const headers = {
      authorization: { bearer: accessToken },
    };

    return api.patch('/user', { languageCode }, headers)
      .then((response) => {
        return dispatch({ type: FETCH_UPDATE_USER_LANGUAGE, payload: languageCode });
      })
      .catch(handle401(dispatch));
  };
};



// WEBPACK FOOTER //
// ./src/actions/users.js